// Application-wide constants
export const APP_CONFIG = {
  // URLs
  BASE_URL: typeof window !== 'undefined' ? window.location.origin : 'https://app.zippity.app',
  SUPPORT_EMAIL: 'support@zippity.app',

  // Polling intervals (in milliseconds)
  NOTIFICATION_POLL_INTERVAL: 30000, // 30 seconds
  ANALYTICS_POLL_INTERVAL: 60000, // 1 minute

  // Animation durations (in milliseconds)
  TOAST_DURATION: 3000,
  COPY_TIMEOUT: 2000,

  // Pagination defaults
  DEFAULT_PAGE_SIZE: 50,
  MAX_PAGE_SIZE: 100,

  // Form validation
  MIN_FEEDBACK_LENGTH: 8,

  // External service URLs
  EXTERNAL_URLS: {
    ROADMAP: 'https://zippity.app/roadmap',
    POSTHOG: 'https://app.posthog.com',
  },

  // Storage keys
  STORAGE_KEYS: {
    ONBOARDING_STATE: 'onboarding-state-v1',
    PWA_INSTALL_DISMISSED: 'pwa-install-dismissed',
    PWA_INSTALLED: 'pwa-installed',
    RECAP_OPT_IN: 'weekly-recap-opt-in',
    TOUR_SEEN: 'tour-seen',
  },

  // Tour configuration
  TOUR: {
    REMEMBER_STEP: false,
    EXIT_ON_ESCAPE: true,
    KEYBOARD_CONTROLS: true,
    SHOW_STEP_DOTS: true,
    SHOW_STEP_PROGRESS: true,
    DIALOG_ANIMATE: true,
    AUTO_SCROLL: true,
    AUTO_SCROLL_OFFSET: 50,
    AUTO_SCROLL_SMOOTH: true,
    TARGET_PADDING: 20,
  },

  // Error messages
  ERROR_MESSAGES: {
    GENERIC: 'Execution interrupted. Please try again.',
    NETWORK: 'Connection lost. Reconnect and retry.',
    UNAUTHORIZED: 'Sign in is required to continue.',
    FORBIDDEN: "You don't have access to this workspace operation.",
    NOT_FOUND: 'The requested resource is unavailable.',
    RATE_LIMIT: 'Request limit reached. Wait a moment and retry.',
  },

  // Success messages
  SUCCESS_MESSAGES: {
    COPIED: 'Copied to clipboard',
    SAVED: 'Changes saved',
    SENT: 'Message sent',
    DELETED: 'Item removed',
  },
} as const

// Type-safe access to config values
export type AppConfig = typeof APP_CONFIG
